module.exports = __webpack_public_path__ + "assets/img/29_193.0f194973.jpg";